import imageBethH from '~/images/testimonials/beth-h.jpg';
import imageDavidP from '~/images/testimonials/david-p.jpg';
import imageJenniferR from '~/images/testimonials/jennifer-r2.jpg';
import imageKirstinH from '~/images/testimonials/kirstin-h.jpg';
import imageStevenG from '~/images/testimonials/steven-g.jpg';

const testimonials = [
  {
    content:
      '… A letter or will seems so impersonal. The idea that I can express my love in a video testimonial and have it as a lasting legacy to my family and loved ones, is incredibly fascinating to me. Thank you for presenting this opportunity as a component to my estate plans.',
    author: {
      name: '~ David P.',
      image: imageDavidP,
    },
  },
  {
    content:
      '… While many creative tools and solutions now exist to stage and organize many retirement and estate planning needs, there is currently no service we know about that offers future-timed, customizable personal messaging to loved ones after memory loss or death. This service concept, presented by Sunset Messages, transcends well beyond standard financial and estate planning, and creates a powerful bridge between generations to pass forward memories, love, values, and legacy. …',
    author: {
      name: '~ Kirstin H.',
      image: imageKirstinH,
    },
  },
  {
    content:
      'None of us knows if we’ll get the chance to say what we really want to say to the people we love.  So having an app that lets me compose meaningful messages to family and friends—especially when I have time to sit down and think about what really matters—this is a great service.',
    author: {
      name: '~ Jennifer R.',
      image: imageJenniferR,
    },
  },
  {
    content:
      '… Sunset Messages offers a unique and powerful platform for people to share messages with their loved ones after they die leaving a legacy in ways that people often desire to do but don’t have a way to do so. …',
    author: {
      name: '~ Steven G.',
      image: imageStevenG,
    },
  },
  {
    content:
      '… I don’t know of many people that are excited about planning for their death. But it’s something that we should all do so that not only are we not a burden to our survivors but now our messages can be a gift and live with our families beyond our time. …',
    author: {
      name: '~ Beth H.',
      image: imageBethH,
    },
  },
];

function QuoteIcon(props: any) {
  return (
    <svg
      aria-hidden="true"
      width={105}
      height={78}
      fill="currentColor"
      {...props}
    >
      <path d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z" />
    </svg>
  );
}

export function Testimonials() {
  return (
    <section
      id="testimonials"
      aria-label="What our customers are saying"
      className="py-20 sm:pb-12 sm:pt-32"
    >
      <div>
        <div className="mx-auto md:text-center">
          <h2 className="text-2xl font-bold tracking-tight text-ssm-purple sm:text-4xl">
            What others are saying about
            <br />
            Sunset Messages
          </h2>
        </div>
        <ul className="mx-auto mt-4 flex flex-col flex-wrap justify-center gap-6 sm:mt-8 sm:gap-8 sm:gap-y-10 md:flex-row lg:mt-8 lg:max-w-none">
          {testimonials.map((testimonial, index) => (
            <li key={index} className="basis-1/3">
              <figure className="relative rounded-2xl bg-white p-6 shadow-lg shadow-violet-900/30">
                <QuoteIcon className="absolute left-6 top-6 text-violet-200/75" />
                <blockquote className="relative">
                  <p className="text-lg tracking-tight text-slate-900">
                    {testimonial.content}
                  </p>
                </blockquote>
                <figcaption className="relative mt-6 flex items-center justify-between border-t border-violet-100 pt-6">
                  <div>
                    <div className="font-display text-base text-slate-900">
                      {testimonial.author.name}
                    </div>
                  </div>
                  <div className="overflow-hidden rounded-full bg-slate-50">
                    <img
                      className="h-14 w-14 object-cover"
                      src={testimonial.author.image}
                      alt=""
                      width={56}
                      height={56}
                    />
                  </div>
                </figcaption>
              </figure>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
